import {
    CardColor,
    CardSize,
    LogoCard,
    Logos,
    TagColors
} from "pu-crossproduct-components/build/components/Organisms/Navigation/Card";
import React from "react";
import {useTranslation} from "react-i18next";

interface IAccount {
    accountLogin: string
    accountName: string
    isDisabled: boolean
    isLocked: boolean
    accountId: string
}

export interface IProps {
    account: IAccount
    clickHandle: (account: IAccount) => void
}

export const AccountCard: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const color = props.account.isDisabled
                    ? CardColor.destructive
                    : props.account.isLocked
                        ? CardColor.alert
                        : CardColor.primary;

    const tagText = props.account.isDisabled
                    ? t("twoFactorInformatAccountPickerDisabledTag")
                    : props.account.isLocked
                        ? t("twoFactorInformatAccountPickerLockedTag")
                        : undefined

    return <LogoCard size={CardSize.large}
                     logo={Logos.informatIcon}
                     onClick={() => props.clickHandle(props.account)}
                     secondaryText={props.account.accountLogin}
                     key={props.account.accountId}
                     color={color}
                     tagText={tagText}
    >{props.account.accountName}</LogoCard>
}
